<script setup lang="ts">
import type BuyersConciergeInputVariant from '@consumer/enums/BuyersConciergeInputVariant'
import ConciergeInput from './ConciergeInput.vue'
import ConciergeMadlibs from './ConciergeMadlibs.vue'

// The seam between the two concierge input UIs. Both write the same store and
// build the same request, so picking one is a single switch — nothing downstream
// changes. The variant is threaded in as an SSR prop from the landing page (and
// selectable via the ?concierge_ui override today); once the UI experiment is
// registered it'll carry the buyer's assignment.
export type ConciergeInputVariantName = BuyersConciergeInputVariant

withDefaults(defineProps<{
  variant: ConciergeInputVariantName
}>(), {  })
</script>

<template>
  <ConciergeInput v-if="variant === 'free_text'"/>
  <ConciergeMadlibs v-else/>
</template>
